import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import store from '@/state/store'
// import routes from './routes'

Vue.use(VueRouter)

Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes : store.state.authfack.user.role ==1 ?[
    {
      path: "/",
      name: "default",
      meta: {
        authRequired: true,
      },
      component: () => import("./views/dashboards/principal/index"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/account/login"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters["auth/loggedIn"]) {
            // Redirect to the home page instead
            next({ name: "default" });
          } else {
            // Continue to the login page
            next();
          }
        },
      },
    },
    {
      path: "/logout",
      name: "logout",
      meta: {
        authRequired: true,
        beforeResolve(routeTo, routeFrom, next) {
          if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
            store.dispatch("auth/logOut");
          } else {
            store.dispatch("authfack/logout");
          }
          const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
            route.push("/login")
          );
          // Navigate back to previous page, or home as a fallback
          next(
            authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
          );
        },
      },
    },
    {
      path: "/404",
      name: "404",
      component: require("./views/utility/404").default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
      path: "*",
      redirect: "404",
    },
  
    {
      path: "/calendar",
      name: "Calendar",
      meta: { authRequired: true },
      component: () => import("./views/calendar/calendar"),
    },
    //Inventario
    {
      path: "/inventario/products",
      name: "Products",
      meta: { authRequired: true },
      component: () => import("./views/inventario/products"),
    },
       {
      path: "/inventario/concentrado",
      name: "concentrado",
      meta: { authRequired: true },
      component: () => import("./views/inventario/concentrado/concentrado"),
    }, 
    {
      path: "/inventario/medicina",
      name: "medicina",
      meta: { authRequired: true },
      component: () => import("./views/inventario/medicina/medicina"),
    }, 
    {
      path: "/tipo_animal/tipo_animal",
      name: "tipo_animal",
      meta: { authRequired: true },
      component: () => import("./views/animales/tipoanimal"),
    }, 
    {
      path: "/cerdos/cerdos",
      name: "cerdos",
      meta: { authRequired: true },
      component: () => import("./views/animales/cerdos"),
    }, 
    {
      path: "/cerdos/lotes",
      name: "lotes",
      meta: { authRequired: true },
      component: () => import("./views/animales/Lotes"),
    }, 
    {
      path: "/cerdos/asignacion_corrales/:page_a/:lote_a",
      name: "asignacion_corrales",
      meta: { authRequired: true },
      component: () => import("./views/animales/LoteAnimal"),
    }, 
    {
      path: "/cerdos/asignacion_corrales/new",
      name: "new_asignacion_corrales",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewLoteAnimal"),
    }, 
    {
      path: "/cerdos/asignacion_corrales/new_l",
      name: "new_asignacion_corrales_l",
      meta: { authRequired: true },
      component: () => import("./views/animales/newTrasladoL"),
    }, 
    {
      path: "/cerdos/vista_lote/:id/:page/:lote_a",
      name: "vista_lote",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewLoteAnimal"),
    }, 
    {
      path: "/cerdos/inseminacion",
      name: "inseminacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/Inseminacion"),
    }, 
    {
      path: "/cerdos/view_inseminacion/:id",
      name: "view_inseminacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewInseminacion"),
    },
    {
      path: "/cerdos/traslado",
      name: "traslado",
      meta: { authRequired: true },
      component: () => import("./views/animales/TrasladoParto"),
    }, 
    {
      path: "/cerdos/traslado/new",
      name: "new_traslado",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewTrasladoCerdo"),
    }, 
    {
      path: "/cerdos/traslado/new_gestacion/:idlote",
      name: "new_traslado_gestacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/TrasladoGestacion"),
    }, 
    {
      path: "/cerdos/traslado/new_descarte/:idlote",
      name: "new_descarte",
      meta: { authRequired: true },
      component: () => import("./views/animales/TrasladoDescarte"),
    }, 
    {
      path: "/cerdos/reacomodo/new/:idlote",
      name: "new_reacomdo",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewReacomodo"),
    }, 
    {
      path: "/cerdos/destete/new/:idlote",
      name: "new_destete",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewDestete"),
    }, 
    {
      path: "/cerdos/traslado_engorde/new/:idlote",
      name: "new_traslado_21",
      meta: { authRequired: true },
      component: () => import("./views/animales/newTrasladoEngorde"),
    }, 
    {
      path: "/cerdos/inseminacion/new",
      name: "new_inseminacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewInseminacion"),
    }, 
    {
      path: "/cerdos/vista_lote/parto/:idlote/:idcerdo",
      name: "new_parto",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewParto"),
    }, 
    {
      path: "/alimento/AsignacionAlimento",
      name: "AsignacionAlimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/AsignacionAlimento"),
    }, 
    
    
    {
      path: "/alimento/AsignacionAlimento/new",
      name: "new_AsignacionAlimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewAsignacionAlimento"),
    }, 
    {
      path: "/alimento/view_asignacion/:id",
      name: "vista_asignacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewAsignacion"),
    }, 
    {
      path: "/alimento/listado_lotes_alimento",
      name: "listado_lotes_alimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/ListadoLotesAlimento"),
    }, 
    {
      path: "/alimento/listado_lotes_concentrado/:id/:nombre_producto",
      name: "listado_lotes_concentrado",
      meta: { authRequired: true },
      component: () => import("./views/animales/ListadoLoteByConcentrado"),
    }, 
    



    // {
    //   path: "/inventario/gastosinternos",
    //   name: "gastosinternos",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/gastosinternos"),
    // },
    // {
    //   path: "/inventario/servicios",
    //   name: "servicios",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/servicios"),
    // },
    // {
    //   path: "/inventario/marcas",
    //   name: "marcas",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/marcas/marcas"),
    // },
    // {
    //   path: "/inventario/tiendas",
    //   name: "tiendas",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/sucursal/tiendas"),
    // },
    // {
    //   path: "/inventario/bodegas",
    //   name: "bodegas",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/sucursal/bodegas"),
    // },
    // {
    //   path: "/inventario/detalleDepartamentos/:id/:estado",
    //   name: "detalleDepartamentos",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/sucursal/detalleDepartamentos"),
    // },
    // {
    //   path: "/inventario/unidades",
    //   name: "unidades",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/unidades/presentaciones"),
    // },
    // /* {
    //   path: "/inventario/detallePresentaciones/:id",
    //   name: "detallePresentaciones",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/presentacion/detallePresentaciones"),
    // }, */
    // {
    //   path: "/inventario/autos",
    //   name: "autos",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/autos/autos"),
    // },
    // {
    //   path: "/inventario/autosdetail/:id",
    //   name: "autosdetail",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/autos/autosdetail"),
    // },
    // {
    //   path: "/inventario/productos",
    //   name: "productos",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/productos"),
    // },
    // {
    //   // Traslado
    //   path: "/inventario/traslados",
    //   name: "traslados",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/traslado/traslado"),
    // },
    // {
    //   // Nueva Traslado
    //   path: "/inventario/nuevo-traslado",
    //   name: "nuevotraslado",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/traslado/newTraslado"),
    // },
    // {
    //   path: "/inventario/detailtraslado/:id",
    //   name: "detailtraslado",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/traslado/viewTraslado"),
    // },
    // {
    //   path: "/inventario/detailproducto/:id",
    //   name: "detailproducto",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/detailproducto"),
    // },
    // {
    //   path: "/inventario/stockproducto/:id",
    //   name: "stockproducto",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/stockproducto"),
    // },
    // {
    //   path: "/inventario/imprimirproducto/:departamento/:estante",
    //   name: "imprimirproducto",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/imprimirproductos"),
    // },
    // {
    //   path: "/inventario/viewstock/:id",
    //   name: "viewstock",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/viewstock"),
    // },
    // {
    //   path: "/inventario/historial_precios/:id",
    //   name: "historial_precios",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/historial_precios"),
    // },
    // {
    //   path: "/inventario/cardex/:id/:fecha_ini/:fecha_fin",
    //   name: "cardex",
    //   meta: { authRequired: true },
    //   component: () => import("./views/inventario/productos/cardex"),
    // },
    // //Administracion
    // {
    //   path: "/administracion/cargoLaboral",
    //   name: "cargoLaboral",
    //   meta: { authRequired: true },
    //   component: () => import("./views/administracion/cargoLaboral"),
    // },
    {
      path: "/administracion/empleados",
      name: "empleados",
      meta: { authRequired: true },
      component: () => import("./views/administracion/empleados"),
    },
    {
      path: "/administracion/productosdeBaja",
      name: "productosdeBaja",
      meta: { authRequired: true },
      component: () => import("./views/administracion/productosdeBaja"),
    },
    {
      path: "/administracion/proveedores",
      name: "proveedores",
      meta: { authRequired: true },
      component: () => import("./views/administracion/proveedores"),
    },
    {
      path: "/administracion/usuarios_especiales",
      name: "usuarios_especiales",
      meta: { authRequired: true },
      component: () => import("./views/administracion/usuarios_especiales"),
    },
    {
      path: "/administracion/usuarios",
      name: "usuarios",
      meta: { authRequired: true },
      component: () => import("./views/administracion/usuarios"),
    },
    {
      path: "/administracion/reportes",
      name: "reportes",
      meta: { authRequired: true },
      component: () => import("./views/administracion/reportes/Reportes"),
    },
  
    //Demostraciones
    {
      path: "/demo/catalogoProducto",
      name: "catalogoProducto",
      meta: { authRequired: true },
      component: () => import("./views/demo/catalogoProducto"),
    },
    // Ventas
    {
      // Clientes
  
      path: "/ventas/cliente",
      name: "Clientes",
      meta: { authRequired: true },
      component: () => import("./views/ventas/Cliente"),
    },
    {
      // Servicios
  
      path: "/ventas/servicio",
      name: "Servicios",
      meta: { authRequired: true },
      component: () => import("./views/ventas/Servicios"),
    },
    {
      // Dias de vencimiento
  
      path: "/ventas/dias-vencimiento",
      name: "Días de vencimiento",
      meta: { authRequired: true },
      component: () => import("./views/ventas/DiasVencimiento"),
    },
    {
      // Cotizacion
      path: "/ventas/cotizacion",
      name: "Cotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/Cotizacion"),
    },
    {
      // Nueva cotizacion
      path: "/ventas/cotizacion/nueva-cotizacion",
      name: "nuevaCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/NuevaCotizacion"),
    },
    {
      // Editar cotizacion
      path: "/ventas/cotizacion/editar-cotizacion/:id",
      name: "editarCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/EditarCotizacion"),
    },
    {
      // Vista cotizacion
      path: "/ventas/cotizacion/vista-cotizacion/:id",
      name: "vistaCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/VistaCotizacion"),
    },
    {
      // Imprimir cotizacion
      path: "/ventas/cotizacion/imprimir-cotizacion/:id",
      name: "imprimirCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/ImprimirCotizacion"),
    },
    {
      // Ventas
      path: "/ventas/venta",
      name: "ventas",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/Ventas"),
    },
    {
      // Taler
      path: "/ventas/taller",
      name: "taller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/Taller.vue"),
    },
    {
      // Nueva taller
      path: "/ventas/nuevo-servicio",
      name: "nuevoServicio",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/NewTaller.vue"),
    },
    {
      // Diagnostico Taller
      path: "/ventas/diagnostico-taller/:id",
      name: "diagnosticoTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/DiagnosticoReparacion.vue"),
    },
    {
      // Ver taller
      path: "/ventas/view-taller/:id",
      name: "verTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/viewTaller.vue"),
    },
    {
      // Ver taller
      path: "/ventas/recibo-taller/:id",
      name: "reciboTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/reciboCotizacion.vue"),
    },
    {
      // Creditos taller
      path: "/ventas/creditos-taller",
      name: "creditosTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/CreditoTaller.vue"),
    },
    {
      // viewCreditoTaller
      path: "/ventas/creditos-taller/:id",
      name: "vistaCreditoTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/viewCreditoTaller.vue"),
    },
    {
      // Cotizacion a venta
      path: "/ventas/cotizacion-venta",
      name: "cotizacionVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/CotizacionVenta"),
    },
    {
      // Nueva venta
      path: "/ventas/nueva-venta",
      name: "nuevaVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/NuevaVenta"),
    },
    {
      // Nueva venta credito
      path: "/ventas/venta-credito",
      name: "ventaCredito",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VentaCredito"),
    },
    {
      // Vista venta
      path: "/ventas/vista-venta/:id",
      name: "vistaVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VistaVenta"),
    },
    {
      // Imprimir venta
      path: "/ventas/imprimir-ticket/:id",
      name: "imprimirTicket",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/ImprimirTicket"),
    },
    {
      // Creditos ventas
      path: "/ventas/creditos-venta",
      name: "creditosVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/CreditosVenta.vue"),
    },
    {
      // Creditos ventas
      path: "/ventas/vista-creditos/:id",
      name: "vistaCreditosVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VistaCreditos.vue"),
    },
   
    // Caja
    {
      path: "/caja/procesarVenta/",
      name: "procesarVenta",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/ProcesarVenta.vue"),
    },
    {
      path: "/caja/inicioCaja",
      name: "inicioCaja",
      meta: { authRequired: true },
      component: () => import("./views/caja/registro/InicioCaja.vue"),
    },
    {
      path: "/caja/ventasProcesadas",
      name: "procesadas",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/VentasProcesadas.vue"),
    },
    {
      path: "/caja/imprimirProcesada/:id",
      name: "imprimirProcesada",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/ImprimirProcesada.vue"),
    },
    {
      path: "/caja/verVentaProcesada/:id",
      name: "verVentaProcesada",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/VerVentaProcesada.vue"),
    },
    {
      // Creditos ventas
      path: "/caja/corteCaja",
      name: "corteCaja",
      meta: { authRequired: true },
      component: () => import("./views/caja/corte/CorteCaja.vue"),
    },
    {
      // imprimir cierre.
      path: "/caja/view-caja/:id",
      name: "vistaComprobanteCaja",
      meta: { authRequired: true },
      component: () => import("./views/caja/registro//imprimirCierre.vue"),
    },
    //Compras
    //compra cerdo
    {
      path: "/compras/compras_cerdos",
      name: "compras_cerdos",
      meta: { authRequired: true },
      component: () => import("./views/compras/compraCerdos"),
    },
    
    {
      path: "/compras/newCompraCerdo",
      name: "new_compra_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/newCompraCerdo"),
    },
    {
      path: "/compras/view_compra_cerdo/:id",
      name: "view_compra_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/viewCompraCerdos"),
    },
    {
      path: "/compras/credito_cerdos",
      name: "credito_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/CreditoCerdos"),
    },
    {
      path: "/compras/view_credito_cerdo/:id",
      name: "view_credito_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/viewCreditoCerdo"),
    },

    {
      path: "/compras/newCompra",
      name: "newCompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/newCompra"),
    },
    {
      path: "/compras/newCompraMedicina",
      name: "newCompraMedicina",
      meta: { authRequired: true },
      component: () => import("./views/compras/newCompraMedicina"),
    },
    {
      path: "/compras/compras",
      name: "compras",
      meta: { authRequired: true },
      component: () => import("./views/compras/compras"),
    },
    {
      path: "/compras/compras_medicina",
      name: "compras_medicina",
      meta: { authRequired: true },
      component: () => import("./views/compras/comprasMedicina"),
    },
    {
      path: "/compras/proveedor/",
      name: "proveedor",
      meta: { authRequired: true },
      component: () => import("./views/compras/proveedores/proveedor"),
    },
    {
      path: "/compras/newOrden",
      name: "newOrden",
      meta: { authRequired: true },
      component: () => import("./views/compras/newOrden"),
    },
    {
      path: "/compras/credito",
      name: "credito",
      meta: { authRequired: true },
      component: () => import("./views/compras/credito"),
    },
    {
      path: "/compras/ordendecompra",
      name: "ordendecompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/ordendecompra"),
    },
    {
      path: "/compras/vistadecompras/:id",
      name: "vistadecompras",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistadecompras"),
    },
    {
      path: "/compras/vistadecomprasmedicina/:id",
      name: "vistadecomprasmedicina",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistadecomprasmedicina"),
    },
    {
      path: "/compras/vistacreditos/:id",
      name: "vistacreditos",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistacreditos"),
    },
    {
      path: "/compras/vistadeorden/:id",
      name: "vistadeorden",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistadeorden"),
    },
    {
      path: "/compras/imprimirorden/:id",
      name: "imprimirorden",
      meta: { authRequired: true },
      component: () => import("./views/compras/imprimirorden"),
    },
    {
      path: "/compras/imprimircompra/:id",
      name: "imprimircompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/imprimircompra"),
    },
    //Reportes

  
    // {
    //   path: "/pages/starter",
    //   name: "Starter",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/starter"),
    // },
    // {
    //   path: "/pages/maintenance",
    //   name: "Maintenance",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/maintenance"),
    // },
    // {
    //   path: "/pages/coming-soon",
    //   name: "coming-soon",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/coming-soon"),
    // },
    // {
    //   path: "/pages/timeline",
    //   name: "Timeline",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/timeline"),
    // },
    // {
    //   path: "/pages/faqs",
    //   name: "FAQs",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/faqs"),
    // },
    // {
    //   path: "/pages/pricing",
    //   name: "Pricing",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/pricing"),
    // },
    {
      path: "/pages/404",
      name: "Error-404",
      meta: { authRequired: true },
      component: () => import("./views/utility/404"),
    },
    {
      path: "/pages/500",
      name: "Error-500",
      meta: { authRequired: true },
      component: () => import("./views/utility/500"),
    },
  
    // {
    //   path: "/auth/login-1",
    //   name: "Login sample",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/login-sample"),
    // },
    // {
    //   path: "/auth/login-2",
    //   name: "Login-2-sample",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/login-2"),
    // },
    // {
    //   path: "/auth/register-1",
    //   name: "Register sample",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/register-sample"),
    // },
    // {
    //   path: "/auth/register-2",
    //   name: "Register-2",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/register-2"),
    // },
    // {
    //   path: "/auth/recoverpwd",
    //   name: "Recover pwd",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/recoverpw-sample"),
    // },
    // {
    //   path: "/auth/recoverpwd-2",
    //   name: "Recover pwd-2",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/recoverpwd-2"),
    // },
    // {
    //   path: "/auth/lock-screen",
    //   name: "Lock screen",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/lockscreen"),
    // },
    // {
    //   path: "/auth/lock-screen-2",
    //   name: "Lock screen-2",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/lockscreen-2"),
    // },
    // {
    //   path: "/auth/confirm-mail",
    //   name: "confirm-mail",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/confirm-mail"),
    // },
    // {
    //   path: "/auth/confirm-mail-2",
    //   name: "confirm-mail-2",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/confirm-mail-2"),
    // },
    // {
    //   path: "/auth/email-verification",
    //   name: "email-verification",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/email-verification"),
    // },
    // {
    //   path: "/auth/email-verification-2",
    //   name: "email-verification-2",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/email-verification-2"),
    // },
    // {
    //   path: "/auth/two-step-verification",
    //   name: "two-step-verification",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/two-step-verification"),
    // },
    // {
    //   path: "/auth/two-step-verification-2",
    //   name: "two-step-verification-2",
    //   meta: { authRequired: true },
    //   component: () => import("./views/sample-pages/two-step-verification-2"),
    // },
  ]:
  store.state.authfack.user.role ==2 ? [
    {
      path: "/",
      name: "default",
      meta: {
        authRequired: true,
      },
      component: () => import("./views/dashboards/principal/index"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/account/login"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters["auth/loggedIn"]) {
            // Redirect to the home page instead
            next({ name: "default" });
          } else {
            // Continue to the login page
            next();
          }
        },
      },
    },
    {
      path: "/logout",
      name: "logout",
      meta: {
        authRequired: true,
        beforeResolve(routeTo, routeFrom, next) {
          if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
            store.dispatch("auth/logOut");
          } else {
            store.dispatch("authfack/logout");
          }
          const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
            route.push("/login")
          );
          // Navigate back to previous page, or home as a fallback
          next(
            authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
          );
        },
      },
    },
    {
      path: "/404",
      name: "404",
      component: require("./views/utility/404").default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
      path: "*",
      redirect: "404",
    },
  
    {
      path: "/calendar",
      name: "Calendar",
      meta: { authRequired: true },
      component: () => import("./views/calendar/calendar"),
    },
    {
      path: "/alimento/AsignacionAlimento",
      name: "AsignacionAlimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/AsignacionAlimento"),
    }, 
    
    
    {
      path: "/alimento/AsignacionAlimento/new",
      name: "new_AsignacionAlimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewAsignacionAlimento"),
    }, 
    {
      path: "/alimento/view_asignacion/:id",
      name: "vista_asignacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewAsignacion"),
    }, 
    {
      path: "/alimento/listado_lotes_alimento",
      name: "listado_lotes_alimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/ListadoLotesAlimento"),
    }, 
    {
      path: "/alimento/listado_lotes_concentrado/:id/:nombre_producto",
      name: "listado_lotes_concentrado",
      meta: { authRequired: true },
      component: () => import("./views/animales/ListadoLoteByConcentrado"),
    }, 
    



    // Ventas
    {
      // Clientes
  
      path: "/ventas/cliente",
      name: "Clientes",
      meta: { authRequired: true },
      component: () => import("./views/ventas/Cliente"),
    },
    {
      // Servicios
  
      path: "/ventas/servicio",
      name: "Servicios",
      meta: { authRequired: true },
      component: () => import("./views/ventas/Servicios"),
    },
    {
      // Dias de vencimiento
  
      path: "/ventas/dias-vencimiento",
      name: "Días de vencimiento",
      meta: { authRequired: true },
      component: () => import("./views/ventas/DiasVencimiento"),
    },
    {
      // Cotizacion
      path: "/ventas/cotizacion",
      name: "Cotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/Cotizacion"),
    },
    {
      // Nueva cotizacion
      path: "/ventas/cotizacion/nueva-cotizacion",
      name: "nuevaCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/NuevaCotizacion"),
    },
    {
      // Editar cotizacion
      path: "/ventas/cotizacion/editar-cotizacion/:id",
      name: "editarCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/EditarCotizacion"),
    },
    {
      // Vista cotizacion
      path: "/ventas/cotizacion/vista-cotizacion/:id",
      name: "vistaCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/VistaCotizacion"),
    },
    {
      // Imprimir cotizacion
      path: "/ventas/cotizacion/imprimir-cotizacion/:id",
      name: "imprimirCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/ImprimirCotizacion"),
    },
    {
      // Ventas
      path: "/ventas/venta",
      name: "ventas",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/Ventas"),
    },
    {
      // Taler
      path: "/ventas/taller",
      name: "taller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/Taller.vue"),
    },
    {
      // Nueva taller
      path: "/ventas/nuevo-servicio",
      name: "nuevoServicio",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/NewTaller.vue"),
    },
    {
      // Diagnostico Taller
      path: "/ventas/diagnostico-taller/:id",
      name: "diagnosticoTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/DiagnosticoReparacion.vue"),
    },
    {
      // Ver taller
      path: "/ventas/view-taller/:id",
      name: "verTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/viewTaller.vue"),
    },
    {
      // Ver taller
      path: "/ventas/recibo-taller/:id",
      name: "reciboTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/reciboCotizacion.vue"),
    },
    {
      // Creditos taller
      path: "/ventas/creditos-taller",
      name: "creditosTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/CreditoTaller.vue"),
    },
    {
      // viewCreditoTaller
      path: "/ventas/creditos-taller/:id",
      name: "vistaCreditoTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/viewCreditoTaller.vue"),
    },
    {
      // Cotizacion a venta
      path: "/ventas/cotizacion-venta",
      name: "cotizacionVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/CotizacionVenta"),
    },
    {
      // Nueva venta
      path: "/ventas/nueva-venta",
      name: "nuevaVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/NuevaVenta"),
    },
    {
      // Nueva venta credito
      path: "/ventas/venta-credito",
      name: "ventaCredito",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VentaCredito"),
    },
    {
      // Vista venta
      path: "/ventas/vista-venta/:id",
      name: "vistaVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VistaVenta"),
    },
    {
      // Imprimir venta
      path: "/ventas/imprimir-ticket/:id",
      name: "imprimirTicket",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/ImprimirTicket"),
    },
    {
      // Creditos ventas
      path: "/ventas/creditos-venta",
      name: "creditosVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/CreditosVenta.vue"),
    },
    {
      // Creditos ventas
      path: "/ventas/vista-creditos/:id",
      name: "vistaCreditosVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VistaCreditos.vue"),
    },
   
    // Caja
    {
      path: "/caja/procesarVenta/",
      name: "procesarVenta",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/ProcesarVenta.vue"),
    },
    {
      path: "/caja/inicioCaja",
      name: "inicioCaja",
      meta: { authRequired: true },
      component: () => import("./views/caja/registro/InicioCaja.vue"),
    },
    {
      path: "/caja/ventasProcesadas",
      name: "procesadas",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/VentasProcesadas.vue"),
    },
    {
      path: "/caja/imprimirProcesada/:id",
      name: "imprimirProcesada",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/ImprimirProcesada.vue"),
    },
    {
      path: "/caja/verVentaProcesada/:id",
      name: "verVentaProcesada",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/VerVentaProcesada.vue"),
    },

    //Compras
    //compra cerdo
  
   
    {
      path: "/compras/imprimircompra/:id",
      name: "imprimircompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/imprimircompra"),
    },
    {
      path: "/pages/404",
      name: "Error-404",
      meta: { authRequired: true },
      component: () => import("./views/utility/404"),
    },
    {
      path: "/pages/500",
      name: "Error-500",
      meta: { authRequired: true },
      component: () => import("./views/utility/500"),
    },
  
  ]
 : store.state.authfack.user.role ==3 ?[
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/principal/index"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },

  {
    path: "/calendar",
    name: "Calendar",
    meta: { authRequired: true },
    component: () => import("./views/calendar/calendar"),
  },
  {
    path: "/cerdos/lotes",
    name: "lotes",
    meta: { authRequired: true },
    component: () => import("./views/animales/Lotes"),
  }, 
  {
    path: "/cerdos/asignacion_corrales/:page_a/:lote_a",
    name: "asignacion_corrales",
    meta: { authRequired: true },
    component: () => import("./views/animales/LoteAnimal"),
  }, 
  {
    path: "/cerdos/asignacion_corrales/new",
    name: "new_asignacion_corrales",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewLoteAnimal"),
  }, 
  {
    path: "/cerdos/asignacion_corrales/new_l",
    name: "new_asignacion_corrales_l",
    meta: { authRequired: true },
    component: () => import("./views/animales/newTrasladoL"),
  }, 
  {
    path: "/cerdos/vista_lote/:id/:page/:lote_a",
    name: "vista_lote",
    meta: { authRequired: true },
    component: () => import("./views/animales/viewLoteAnimal"),
  }, 
  {
    path: "/cerdos/inseminacion",
    name: "inseminacion",
    meta: { authRequired: true },
    component: () => import("./views/animales/Inseminacion"),
  }, 
  {
    path: "/cerdos/view_inseminacion/:id",
    name: "view_inseminacion",
    meta: { authRequired: true },
    component: () => import("./views/animales/viewInseminacion"),
  },
  {
    path: "/cerdos/traslado",
    name: "traslado",
    meta: { authRequired: true },
    component: () => import("./views/animales/TrasladoParto"),
  }, 
  {
    path: "/cerdos/traslado/new",
    name: "new_traslado",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewTrasladoCerdo"),
  }, 
  {
    path: "/cerdos/traslado/new_gestacion/:idlote",
    name: "new_traslado_gestacion",
    meta: { authRequired: true },
    component: () => import("./views/animales/TrasladoGestacion"),
  }, 
  {
    path: "/cerdos/traslado/new_descarte/:idlote",
    name: "new_descarte",
    meta: { authRequired: true },
    component: () => import("./views/animales/TrasladoDescarte"),
  }, 
  {
    path: "/cerdos/reacomodo/new/:idlote",
    name: "new_reacomdo",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewReacomodo"),
  }, 
  {
    path: "/cerdos/destete/new/:idlote",
    name: "new_destete",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewDestete"),
  }, 
  {
    path: "/cerdos/traslado_engorde/new/:idlote",
    name: "new_traslado_21",
    meta: { authRequired: true },
    component: () => import("./views/animales/newTrasladoEngorde"),
  }, 
  {
    path: "/cerdos/inseminacion/new",
    name: "new_inseminacion",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewInseminacion"),
  }, 
  {
    path: "/cerdos/vista_lote/parto/:idlote/:idcerdo",
    name: "new_parto",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewParto"),
  }, 
  {
    path: "/alimento/AsignacionAlimento",
    name: "AsignacionAlimento",
    meta: { authRequired: true },
    component: () => import("./views/animales/AsignacionAlimento"),
  }, 
  
  
  {
    path: "/alimento/AsignacionAlimento/new",
    name: "new_AsignacionAlimento",
    meta: { authRequired: true },
    component: () => import("./views/animales/NewAsignacionAlimento"),
  }, 
  {
    path: "/alimento/view_asignacion/:id",
    name: "vista_asignacion",
    meta: { authRequired: true },
    component: () => import("./views/animales/viewAsignacion"),
  }, 
  {
    path: "/alimento/listado_lotes_alimento",
    name: "listado_lotes_alimento",
    meta: { authRequired: true },
    component: () => import("./views/animales/ListadoLotesAlimento"),
  }, 
  {
    path: "/alimento/listado_lotes_concentrado/:id/:nombre_producto",
    name: "listado_lotes_concentrado",
    meta: { authRequired: true },
    component: () => import("./views/animales/ListadoLoteByConcentrado"),
  }, 
  
  {
    path: "/administracion/empleados",
    name: "empleados",
    meta: { authRequired: true },
    component: () => import("./views/administracion/empleados"),
  },
  {
    path: "/administracion/productosdeBaja",
    name: "productosdeBaja",
    meta: { authRequired: true },
    component: () => import("./views/administracion/productosdeBaja"),
  },
  {
    path: "/administracion/proveedores",
    name: "proveedores",
    meta: { authRequired: true },
    component: () => import("./views/administracion/proveedores"),
  },
  {
    path: "/administracion/usuarios_especiales",
    name: "usuarios_especiales",
    meta: { authRequired: true },
    component: () => import("./views/administracion/usuarios_especiales"),
  },
  {
    path: "/administracion/usuarios",
    name: "usuarios",
    meta: { authRequired: true },
    component: () => import("./views/administracion/usuarios"),
  },
  {
    path: "/administracion/reportes",
    name: "reportes",
    meta: { authRequired: true },
    component: () => import("./views/administracion/reportes/Reportes"),
  },

  //Demostraciones
  {
    path: "/demo/catalogoProducto",
    name: "catalogoProducto",
    meta: { authRequired: true },
    component: () => import("./views/demo/catalogoProducto"),
  },
  // Ventas
  {
    // Clientes

    path: "/ventas/cliente",
    name: "Clientes",
    meta: { authRequired: true },
    component: () => import("./views/ventas/Cliente"),
  },
  {
    // Servicios

    path: "/ventas/servicio",
    name: "Servicios",
    meta: { authRequired: true },
    component: () => import("./views/ventas/Servicios"),
  },
  {
    // Dias de vencimiento

    path: "/ventas/dias-vencimiento",
    name: "Días de vencimiento",
    meta: { authRequired: true },
    component: () => import("./views/ventas/DiasVencimiento"),
  },
  {
    // Cotizacion
    path: "/ventas/cotizacion",
    name: "Cotizacion",
    meta: { authRequired: true },
    component: () => import("./views/ventas/cotizacion/Cotizacion"),
  },
  {
    // Nueva cotizacion
    path: "/ventas/cotizacion/nueva-cotizacion",
    name: "nuevaCotizacion",
    meta: { authRequired: true },
    component: () => import("./views/ventas/cotizacion/NuevaCotizacion"),
  },
  {
    // Editar cotizacion
    path: "/ventas/cotizacion/editar-cotizacion/:id",
    name: "editarCotizacion",
    meta: { authRequired: true },
    component: () => import("./views/ventas/cotizacion/EditarCotizacion"),
  },
  {
    // Vista cotizacion
    path: "/ventas/cotizacion/vista-cotizacion/:id",
    name: "vistaCotizacion",
    meta: { authRequired: true },
    component: () => import("./views/ventas/cotizacion/VistaCotizacion"),
  },
  {
    // Imprimir cotizacion
    path: "/ventas/cotizacion/imprimir-cotizacion/:id",
    name: "imprimirCotizacion",
    meta: { authRequired: true },
    component: () => import("./views/ventas/cotizacion/ImprimirCotizacion"),
  },
  {
    // Ventas
    path: "/ventas/venta",
    name: "ventas",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/Ventas"),
  },
  {
    // Taler
    path: "/ventas/taller",
    name: "taller",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/Taller.vue"),
  },
  {
    // Nueva taller
    path: "/ventas/nuevo-servicio",
    name: "nuevoServicio",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/NewTaller.vue"),
  },
  {
    // Diagnostico Taller
    path: "/ventas/diagnostico-taller/:id",
    name: "diagnosticoTaller",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/DiagnosticoReparacion.vue"),
  },
  {
    // Ver taller
    path: "/ventas/view-taller/:id",
    name: "verTaller",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/viewTaller.vue"),
  },
  {
    // Ver taller
    path: "/ventas/recibo-taller/:id",
    name: "reciboTaller",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/reciboCotizacion.vue"),
  },
  {
    // Creditos taller
    path: "/ventas/creditos-taller",
    name: "creditosTaller",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/CreditoTaller.vue"),
  },
  {
    // viewCreditoTaller
    path: "/ventas/creditos-taller/:id",
    name: "vistaCreditoTaller",
    meta: { authRequired: true },
    component: () => import("./views/inventario/taller/viewCreditoTaller.vue"),
  },
  {
    // Cotizacion a venta
    path: "/ventas/cotizacion-venta",
    name: "cotizacionVenta",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/CotizacionVenta"),
  },
  {
    // Nueva venta
    path: "/ventas/nueva-venta",
    name: "nuevaVenta",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/NuevaVenta"),
  },
  {
    // Nueva venta credito
    path: "/ventas/venta-credito",
    name: "ventaCredito",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/VentaCredito"),
  },
  {
    // Vista venta
    path: "/ventas/vista-venta/:id",
    name: "vistaVenta",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/VistaVenta"),
  },
  {
    // Imprimir venta
    path: "/ventas/imprimir-ticket/:id",
    name: "imprimirTicket",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/ImprimirTicket"),
  },
  {
    // Creditos ventas
    path: "/ventas/creditos-venta",
    name: "creditosVenta",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/CreditosVenta.vue"),
  },
  {
    // Creditos ventas
    path: "/ventas/vista-creditos/:id",
    name: "vistaCreditosVenta",
    meta: { authRequired: true },
    component: () => import("./views/ventas/venta/VistaCreditos.vue"),
  },
 
  // Caja
  {
    path: "/caja/procesarVenta/",
    name: "procesarVenta",
    meta: { authRequired: true },
    component: () => import("./views/caja/procesar/ProcesarVenta.vue"),
  },
  {
    path: "/caja/inicioCaja",
    name: "inicioCaja",
    meta: { authRequired: true },
    component: () => import("./views/caja/registro/InicioCaja.vue"),
  },
  {
    path: "/caja/ventasProcesadas",
    name: "procesadas",
    meta: { authRequired: true },
    component: () => import("./views/caja/procesar/VentasProcesadas.vue"),
  },
  {
    path: "/caja/imprimirProcesada/:id",
    name: "imprimirProcesada",
    meta: { authRequired: true },
    component: () => import("./views/caja/procesar/ImprimirProcesada.vue"),
  },
  {
    path: "/caja/verVentaProcesada/:id",
    name: "verVentaProcesada",
    meta: { authRequired: true },
    component: () => import("./views/caja/procesar/VerVentaProcesada.vue"),
  },
  {
    // Creditos ventas
    path: "/caja/corteCaja",
    name: "corteCaja",
    meta: { authRequired: true },
    component: () => import("./views/caja/corte/CorteCaja.vue"),
  },
  {
    // imprimir cierre.
    path: "/caja/view-caja/:id",
    name: "vistaComprobanteCaja",
    meta: { authRequired: true },
    component: () => import("./views/caja/registro//imprimirCierre.vue"),
  },
  //Compras
  //compra cerdo
  {
    path: "/compras/compras_cerdos",
    name: "compras_cerdos",
    meta: { authRequired: true },
    component: () => import("./views/compras/compraCerdos"),
  },
  
  {
    path: "/compras/newCompraCerdo",
    name: "new_compra_cerdo",
    meta: { authRequired: true },
    component: () => import("./views/compras/newCompraCerdo"),
  },
  {
    path: "/compras/view_compra_cerdo/:id",
    name: "view_compra_cerdo",
    meta: { authRequired: true },
    component: () => import("./views/compras/viewCompraCerdos"),
  },
  {
    path: "/compras/credito_cerdos",
    name: "credito_cerdo",
    meta: { authRequired: true },
    component: () => import("./views/compras/CreditoCerdos"),
  },
  {
    path: "/compras/view_credito_cerdo/:id",
    name: "view_credito_cerdo",
    meta: { authRequired: true },
    component: () => import("./views/compras/viewCreditoCerdo"),
  },

  {
    path: "/compras/newCompra",
    name: "newCompra",
    meta: { authRequired: true },
    component: () => import("./views/compras/newCompra"),
  },
  {
    path: "/compras/newCompraMedicina",
    name: "newCompraMedicina",
    meta: { authRequired: true },
    component: () => import("./views/compras/newCompraMedicina"),
  },
  {
    path: "/compras/compras",
    name: "compras",
    meta: { authRequired: true },
    component: () => import("./views/compras/compras"),
  },
  {
    path: "/compras/compras_medicina",
    name: "compras_medicina",
    meta: { authRequired: true },
    component: () => import("./views/compras/comprasMedicina"),
  },
  {
    path: "/compras/proveedor/",
    name: "proveedor",
    meta: { authRequired: true },
    component: () => import("./views/compras/proveedores/proveedor"),
  },
  {
    path: "/compras/newOrden",
    name: "newOrden",
    meta: { authRequired: true },
    component: () => import("./views/compras/newOrden"),
  },
  {
    path: "/compras/credito",
    name: "credito",
    meta: { authRequired: true },
    component: () => import("./views/compras/credito"),
  },
  {
    path: "/compras/ordendecompra",
    name: "ordendecompra",
    meta: { authRequired: true },
    component: () => import("./views/compras/ordendecompra"),
  },
  {
    path: "/compras/vistadecompras/:id",
    name: "vistadecompras",
    meta: { authRequired: true },
    component: () => import("./views/compras/vistadecompras"),
  },
  {
    path: "/compras/vistadecomprasmedicina/:id",
    name: "vistadecomprasmedicina",
    meta: { authRequired: true },
    component: () => import("./views/compras/vistadecomprasmedicina"),
  },
  {
    path: "/compras/vistacreditos/:id",
    name: "vistacreditos",
    meta: { authRequired: true },
    component: () => import("./views/compras/vistacreditos"),
  },
  {
    path: "/compras/vistadeorden/:id",
    name: "vistadeorden",
    meta: { authRequired: true },
    component: () => import("./views/compras/vistadeorden"),
  },
  {
    path: "/compras/imprimirorden/:id",
    name: "imprimirorden",
    meta: { authRequired: true },
    component: () => import("./views/compras/imprimirorden"),
  },
  {
    path: "/compras/imprimircompra/:id",
    name: "imprimircompra",
    meta: { authRequired: true },
    component: () => import("./views/compras/imprimircompra"),
  },
  //Reportes


  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("./views/utility/500"),
  },

]:
  store.state.authfack.user.role == 4 ? [
    {
      path: "/",
      name: "default",
      meta: {
        authRequired: true,
      },
      component: () => import("./views/dashboards/principal/index"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/account/login"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters["auth/loggedIn"]) {
            // Redirect to the home page instead
            next({ name: "default" });
          } else {
            // Continue to the login page
            next();
          }
        },
      },
    },
    {
      path: "/logout",
      name: "logout",
      meta: {
        authRequired: true,
        beforeResolve(routeTo, routeFrom, next) {
          if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
            store.dispatch("auth/logOut");
          } else {
            store.dispatch("authfack/logout");
          }
          const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
            route.push("/login")
          );
          // Navigate back to previous page, or home as a fallback
          next(
            authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
          );
        },
      },
    },
    {
      path: "/404",
      name: "404",
      component: require("./views/utility/404").default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
      path: "*",
      redirect: "404",
    },
  
    {
      path: "/calendar",
      name: "Calendar",
      meta: { authRequired: true },
      component: () => import("./views/calendar/calendar"),
    },
    //Inventario
    {
      path: "/inventario/products",
      name: "Products",
      meta: { authRequired: true },
      component: () => import("./views/inventario/products"),
    },
       {
      path: "/inventario/concentrado",
      name: "concentrado",
      meta: { authRequired: true },
      component: () => import("./views/inventario/concentrado/concentrado"),
    }, 
    {
      path: "/inventario/medicina",
      name: "medicina",
      meta: { authRequired: true },
      component: () => import("./views/inventario/medicina/medicina"),
    }, 
    {
      path: "/tipo_animal/tipo_animal",
      name: "tipo_animal",
      meta: { authRequired: true },
      component: () => import("./views/animales/tipoanimal"),
    }, 
    {
      path: "/cerdos/cerdos",
      name: "cerdos",
      meta: { authRequired: true },
      component: () => import("./views/animales/cerdos"),
    }, 
    {
      path: "/cerdos/lotes",
      name: "lotes",
      meta: { authRequired: true },
      component: () => import("./views/animales/Lotes"),
    }, 
    {
      path: "/cerdos/asignacion_corrales/:page_a/:lote_a",
      name: "asignacion_corrales",
      meta: { authRequired: true },
      component: () => import("./views/animales/LoteAnimal"),
    }, 
    {
      path: "/cerdos/asignacion_corrales/new",
      name: "new_asignacion_corrales",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewLoteAnimal"),
    }, 
    {
      path: "/cerdos/asignacion_corrales/new_l",
      name: "new_asignacion_corrales_l",
      meta: { authRequired: true },
      component: () => import("./views/animales/newTrasladoL"),
    }, 
    {
      path: "/cerdos/vista_lote/:id/:page/:lote_a",
      name: "vista_lote",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewLoteAnimal"),
    }, 
    {
      path: "/cerdos/inseminacion",
      name: "inseminacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/Inseminacion"),
    }, 
    {
      path: "/cerdos/view_inseminacion/:id",
      name: "view_inseminacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewInseminacion"),
    },
    {
      path: "/cerdos/traslado",
      name: "traslado",
      meta: { authRequired: true },
      component: () => import("./views/animales/TrasladoParto"),
    }, 
    {
      path: "/cerdos/traslado/new",
      name: "new_traslado",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewTrasladoCerdo"),
    }, 
    {
      path: "/cerdos/traslado/new_gestacion/:idlote",
      name: "new_traslado_gestacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/TrasladoGestacion"),
    }, 
    {
      path: "/cerdos/traslado/new_descarte/:idlote",
      name: "new_descarte",
      meta: { authRequired: true },
      component: () => import("./views/animales/TrasladoDescarte"),
    }, 
    {
      path: "/cerdos/reacomodo/new/:idlote",
      name: "new_reacomdo",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewReacomodo"),
    }, 
    {
      path: "/cerdos/destete/new/:idlote",
      name: "new_destete",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewDestete"),
    }, 
    {
      path: "/cerdos/traslado_engorde/new/:idlote",
      name: "new_traslado_21",
      meta: { authRequired: true },
      component: () => import("./views/animales/newTrasladoEngorde"),
    }, 
    {
      path: "/cerdos/inseminacion/new",
      name: "new_inseminacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewInseminacion"),
    }, 
    {
      path: "/cerdos/vista_lote/parto/:idlote/:idcerdo",
      name: "new_parto",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewParto"),
    }, 
    {
      path: "/alimento/AsignacionAlimento",
      name: "AsignacionAlimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/AsignacionAlimento"),
    }, 
    
    
    {
      path: "/alimento/AsignacionAlimento/new",
      name: "new_AsignacionAlimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/NewAsignacionAlimento"),
    }, 
    {
      path: "/alimento/view_asignacion/:id",
      name: "vista_asignacion",
      meta: { authRequired: true },
      component: () => import("./views/animales/viewAsignacion"),
    }, 
    {
      path: "/alimento/listado_lotes_alimento",
      name: "listado_lotes_alimento",
      meta: { authRequired: true },
      component: () => import("./views/animales/ListadoLotesAlimento"),
    }, 
    {
      path: "/alimento/listado_lotes_concentrado/:id/:nombre_producto",
      name: "listado_lotes_concentrado",
      meta: { authRequired: true },
      component: () => import("./views/animales/ListadoLoteByConcentrado"),
    }, 
    



    //Demostraciones
    {
      path: "/demo/catalogoProducto",
      name: "catalogoProducto",
      meta: { authRequired: true },
      component: () => import("./views/demo/catalogoProducto"),
    },
    // Ventas
    {
      // Clientes
  
      path: "/ventas/cliente",
      name: "Clientes",
      meta: { authRequired: true },
      component: () => import("./views/ventas/Cliente"),
    },
    {
      // Servicios
  
      path: "/ventas/servicio",
      name: "Servicios",
      meta: { authRequired: true },
      component: () => import("./views/ventas/Servicios"),
    },
    {
      // Dias de vencimiento
  
      path: "/ventas/dias-vencimiento",
      name: "Días de vencimiento",
      meta: { authRequired: true },
      component: () => import("./views/ventas/DiasVencimiento"),
    },
    {
      // Cotizacion
      path: "/ventas/cotizacion",
      name: "Cotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/Cotizacion"),
    },
    {
      // Nueva cotizacion
      path: "/ventas/cotizacion/nueva-cotizacion",
      name: "nuevaCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/NuevaCotizacion"),
    },
    {
      // Editar cotizacion
      path: "/ventas/cotizacion/editar-cotizacion/:id",
      name: "editarCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/EditarCotizacion"),
    },
    {
      // Vista cotizacion
      path: "/ventas/cotizacion/vista-cotizacion/:id",
      name: "vistaCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/VistaCotizacion"),
    },
    {
      // Imprimir cotizacion
      path: "/ventas/cotizacion/imprimir-cotizacion/:id",
      name: "imprimirCotizacion",
      meta: { authRequired: true },
      component: () => import("./views/ventas/cotizacion/ImprimirCotizacion"),
    },
    {
      // Ventas
      path: "/ventas/venta",
      name: "ventas",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/Ventas"),
    },
    {
      // Taler
      path: "/ventas/taller",
      name: "taller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/Taller.vue"),
    },
    {
      // Nueva taller
      path: "/ventas/nuevo-servicio",
      name: "nuevoServicio",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/NewTaller.vue"),
    },
    {
      // Diagnostico Taller
      path: "/ventas/diagnostico-taller/:id",
      name: "diagnosticoTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/DiagnosticoReparacion.vue"),
    },
    {
      // Ver taller
      path: "/ventas/view-taller/:id",
      name: "verTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/viewTaller.vue"),
    },
    {
      // Ver taller
      path: "/ventas/recibo-taller/:id",
      name: "reciboTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/reciboCotizacion.vue"),
    },
    {
      // Creditos taller
      path: "/ventas/creditos-taller",
      name: "creditosTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/CreditoTaller.vue"),
    },
    {
      // viewCreditoTaller
      path: "/ventas/creditos-taller/:id",
      name: "vistaCreditoTaller",
      meta: { authRequired: true },
      component: () => import("./views/inventario/taller/viewCreditoTaller.vue"),
    },
    {
      // Cotizacion a venta
      path: "/ventas/cotizacion-venta",
      name: "cotizacionVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/CotizacionVenta"),
    },
    {
      // Nueva venta
      path: "/ventas/nueva-venta",
      name: "nuevaVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/NuevaVenta"),
    },
    {
      // Nueva venta credito
      path: "/ventas/venta-credito",
      name: "ventaCredito",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VentaCredito"),
    },
    {
      // Vista venta
      path: "/ventas/vista-venta/:id",
      name: "vistaVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VistaVenta"),
    },
    {
      // Imprimir venta
      path: "/ventas/imprimir-ticket/:id",
      name: "imprimirTicket",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/ImprimirTicket"),
    },
    {
      // Creditos ventas
      path: "/ventas/creditos-venta",
      name: "creditosVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/CreditosVenta.vue"),
    },
    {
      // Creditos ventas
      path: "/ventas/vista-creditos/:id",
      name: "vistaCreditosVenta",
      meta: { authRequired: true },
      component: () => import("./views/ventas/venta/VistaCreditos.vue"),
    },
   
    // Caja
    {
      path: "/caja/procesarVenta/",
      name: "procesarVenta",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/ProcesarVenta.vue"),
    },
    {
      path: "/caja/inicioCaja",
      name: "inicioCaja",
      meta: { authRequired: true },
      component: () => import("./views/caja/registro/InicioCaja.vue"),
    },
    {
      path: "/caja/ventasProcesadas",
      name: "procesadas",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/VentasProcesadas.vue"),
    },
    {
      path: "/caja/imprimirProcesada/:id",
      name: "imprimirProcesada",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/ImprimirProcesada.vue"),
    },
    {
      path: "/caja/verVentaProcesada/:id",
      name: "verVentaProcesada",
      meta: { authRequired: true },
      component: () => import("./views/caja/procesar/VerVentaProcesada.vue"),
    },

    //Compras
    //compra cerdo
    {
      path: "/compras/compras_cerdos",
      name: "compras_cerdos",
      meta: { authRequired: true },
      component: () => import("./views/compras/compraCerdos"),
    },
    
    {
      path: "/compras/newCompraCerdo",
      name: "new_compra_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/newCompraCerdo"),
    },
    {
      path: "/compras/view_compra_cerdo/:id",
      name: "view_compra_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/viewCompraCerdos"),
    },
    {
      path: "/compras/credito_cerdos",
      name: "credito_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/CreditoCerdos"),
    },
    {
      path: "/compras/view_credito_cerdo/:id",
      name: "view_credito_cerdo",
      meta: { authRequired: true },
      component: () => import("./views/compras/viewCreditoCerdo"),
    },

    {
      path: "/compras/newCompra",
      name: "newCompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/newCompra"),
    },
    {
      path: "/compras/newCompraMedicina",
      name: "newCompraMedicina",
      meta: { authRequired: true },
      component: () => import("./views/compras/newCompraMedicina"),
    },
    {
      path: "/compras/compras",
      name: "compras",
      meta: { authRequired: true },
      component: () => import("./views/compras/compras"),
    },
    {
      path: "/compras/compras_medicina",
      name: "compras_medicina",
      meta: { authRequired: true },
      component: () => import("./views/compras/comprasMedicina"),
    },
    {
      path: "/compras/proveedor/",
      name: "proveedor",
      meta: { authRequired: true },
      component: () => import("./views/compras/proveedores/proveedor"),
    },
    {
      path: "/compras/newOrden",
      name: "newOrden",
      meta: { authRequired: true },
      component: () => import("./views/compras/newOrden"),
    },
    {
      path: "/compras/credito",
      name: "credito",
      meta: { authRequired: true },
      component: () => import("./views/compras/credito"),
    },
    {
      path: "/compras/ordendecompra",
      name: "ordendecompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/ordendecompra"),
    },
    {
      path: "/compras/vistadecompras/:id",
      name: "vistadecompras",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistadecompras"),
    },
    {
      path: "/compras/vistadecomprasmedicina/:id",
      name: "vistadecomprasmedicina",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistadecomprasmedicina"),
    },
    {
      path: "/compras/vistacreditos/:id",
      name: "vistacreditos",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistacreditos"),
    },
    {
      path: "/compras/vistadeorden/:id",
      name: "vistadeorden",
      meta: { authRequired: true },
      component: () => import("./views/compras/vistadeorden"),
    },
    {
      path: "/compras/imprimirorden/:id",
      name: "imprimirorden",
      meta: { authRequired: true },
      component: () => import("./views/compras/imprimirorden"),
    },
    {
      path: "/compras/imprimircompra/:id",
      name: "imprimircompra",
      meta: { authRequired: true },
      component: () => import("./views/compras/imprimircompra"),
    },
    {
      path: "/pages/404",
      name: "Error-404",
      meta: { authRequired: true },
      component: () => import("./views/utility/404"),
    },
    {
      path: "/pages/500",
      name: "Error-500",
      meta: { authRequired: true },
      component: () => import("./views/utility/500"),
    },
  
  ]
  :
  [
    {
      path: "*",
      redirect: "404",
    },
  
    {
      path: "/calendar",
      name: "Calendar",
      meta: { authRequired: true },
      component: () => import("./views/calendar/calendar"),
    },
    {
      path: "/",
      name: "default",
      meta: {
        authRequired: true,
      },
      component: () => import("./views/dashboards/principal/index"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/account/login"),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters["auth/loggedIn"]) {
            // Redirect to the home page instead
            next({ name: "default" });
          } else {
            // Continue to the login page
            next();
          }
        },
      },
    },
   
    {
      path: "/logout",
      name: "logout",
      meta: {
        authRequired: true,
        beforeResolve(routeTo, routeFrom, next) {
          if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
            store.dispatch("auth/logOut");
          } else {
            store.dispatch("authfack/logout");
          }
          const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
            route.push("/login")
          );
          // Navigate back to previous page, or home as a fallback
          next(
            authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
          );
        },
      },
    },
    {
      path: "/404",
      name: "404",
      component: require("./views/utility/404").default,
    },
    {
      path: "/pages/404",
      name: "Error-404",
      meta: { authRequired: true },
      component: () => import("./views/utility/404"),
    },
    {
      path: "/pages/500",
      name: "Error-500",
      meta: { authRequired: true },
      component: () => import("./views/utility/500"),
    }
  ],
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

    // If auth isn't required for the route, just continue.
    if (!authRequired) return next()

    // If auth is required and the user is logged in...
    if (store.getters['auth/loggedIn']) {
      // Validate the local user token...
      return store.dispatch('auth/validate').then((validUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser ? next() : redirectToLogin()
      })
    }

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin()

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    function redirectToLogin() {
      // Pass the original route to the login component
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
    }
  } else {
    const publicPages = ['/login', '/register', '/forgot-password'];
    const authpage = !publicPages.includes(routeTo.path);
    const loggeduser = localStorage.getItem('user');

    if (authpage && !loggeduser) {
      return next('/login');
    }

    next();
  }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
